import {NgModule} from '@angular/core';

import {ResultatDetailTableComponent} from './resultat-detail-table.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
    ],
  exports: [ResultatDetailTableComponent],
  declarations: [ResultatDetailTableComponent],
  providers: [],
})
export class ResultatDetailTableModule {
}
